import React from 'react';

export default function Button(props){
    return <input className="btn" type={props.type} value={props.value} />
}